var MEAL_CONFIGS = [
    {
        mealKey: "breakfast",
        mealName: "早餐",
        listKey: "breakfastList",
        menuNameKey: "brekkerMenuName",
        ingredientKey: "brekkerMenuInfo",
    },
    {
        mealKey: "lunch",
        mealName: "午餐",
        listKey: "lunchList",
        menuNameKey: "lunchMenuName",
        ingredientKey: "lunchMenuInfo",
    },
    {
        mealKey: "dinner",
        mealName: "晚餐",
        listKey: "dinnerList",
        menuNameKey: "supperMenuName",
        ingredientKey: "supperMenuInfo",
    },
    {
        mealKey: "night",
        mealName: "夜餐",
        listKey: "nightList",
        menuNameKey: "nightMenuName",
        ingredientKey: "nightMenuInfo",
    },
];

function normalizeText(value) {
    if (value === undefined || value === null) {
        return "";
    }

    return String(value).replace(/^\s+|\s+$/g, "");
}

function normalizeMealKey(value) {
    if (value === undefined || value === null) {
        return "";
    }

    var mealMap = {
        "0": "breakfast",
        "1": "lunch",
        "2": "dinner",
        "3": "night",
        breakfast: "breakfast",
        lunch: "lunch",
        dinner: "dinner",
        night: "night",
        早餐: "breakfast",
        中餐: "lunch",
        午餐: "lunch",
        晚餐: "dinner",
        夜餐: "night",
    };

    return mealMap[String(value)] || "";
}

function formatMealPrice(price) {
    var numberPrice = Number(price);

    if (isNaN(numberPrice)) {
        return "0.00元";
    }

    return numberPrice.toFixed(2) + "元";
}

function asArray(value) {
    return Array.isArray(value) ? value : [];
}

function collectNames(list) {
    return asArray(list).reduce(function(result, item) {
        var name = item && item.name ? String(item.name).replace(/^\s+|\s+$/g, "") : "";

        if (name) {
            result.push(name);
        }

        return result;
    }, []);
}

function normalizeIngredientText(value, visible) {
    var text = value === undefined || value === null ? "" : String(value).replace(/^\s+|\s+$/g, "");

    if (text) {
        return text;
    }

    if (visible) {
        return "无";
    }

    return "";
}

function findMealConfig(mealKey) {
    var i;

    for (i = 0; i < MEAL_CONFIGS.length; i += 1) {
        if (MEAL_CONFIGS[i].mealKey === mealKey) {
            return MEAL_CONFIGS[i];
        }
    }

    return null;
}

function createMealPriceMap(mealPriceList) {
    var priceMap = {};

    asArray(mealPriceList).forEach(function(item) {
        var mealKey = normalizeMealKey(item && (item.mealKey || item.name || item.type));

        if (!mealKey) {
            return;
        }

        priceMap[mealKey] = formatMealPrice(item.price);
    });

    return priceMap;
}

function buildMealRow(menuItem, mealConfig, mealPriceMap) {
    var menuNameText = normalizeText(menuItem && menuItem[mealConfig.menuNameKey]);
    var recipeNames = collectNames(menuItem && menuItem[mealConfig.listKey]);
    var recipeText = menuNameText || recipeNames.join("、");
    var visible = !!recipeText;
    var priceText = (mealPriceMap && mealPriceMap[mealConfig.mealKey]) || "0.00元";
    var ingredientText = visible
        ? (normalizeText(menuItem && menuItem[mealConfig.ingredientKey]) || "无")
        : "";

    return {
        mealKey: mealConfig.mealKey,
        mealName: mealConfig.mealName,
        priceText: priceText,
        mealLabel: mealConfig.mealName + "(" + priceText + ")",
        recipeText: recipeText,
        ingredientText: ingredientText,
        visible: visible,
    };
}

function buildNutritionalRecipeSections(input) {
    var mealPriceMap = createMealPriceMap(input && input.tjcData);
    var menuList = asArray(input && input.menuList);

    return menuList.reduce(function(sections, menuItem) {
        var rows = MEAL_CONFIGS.reduce(function(currentRows, mealConfig) {
            var row = buildMealRow(menuItem, mealConfig, mealPriceMap);

            if (row.visible) {
                currentRows.push(row);
            }

            return currentRows;
        }, []);

        if (rows.length) {
            sections.push({
                startDate: menuItem && menuItem.startDate ? menuItem.startDate : "",
                endDate: menuItem && menuItem.endDate ? menuItem.endDate : "",
                rows: rows,
            });
        }

        return sections;
    }, []);
}

module.exports = {
    createMealPriceMap: createMealPriceMap,
    buildNutritionalRecipeSections: buildNutritionalRecipeSections,
    normalizeMealKey: normalizeMealKey,
    findMealConfig: findMealConfig,
    buildMealRow: buildMealRow,
    normalizeIngredientText: normalizeIngredientText,
    asArray: asArray,
};
